import moment from 'moment';

export const YYYYMMDD = 'YYYY-MM-DD';
export const DDMMYYYY = 'DD-MM-YYYY';
export const MMDDYYYY = 'MM-DD-YYYY';
export const DDMMYYYYHHMM = 'DD-MM-YYYY HH:mm';
export const HHMM = 'HH:mm';
export const DDMMMYYYYHHmm = 'DD MMM yyyy HH:mm';
export const dddDDMMM = 'ddd, DD - MMM';
export const MMMM = 'MMMM';
export const MMM = 'MMM';
export const DD = 'DD';
export const YYYY = 'YYYY';
export const MMDDYYYYHHMMA = 'MM-DD-YYYY HH:mm a';
export const DDMMMYYYY = 'DD MMM yyyy';

/* eslint-disable import/prefer-default-export */
export const getAttendanceDateList = (isMonthly) => {
  const midDayOfTheMonth = 15;

  const previousMonth = moment()
    .subtract(1, 'month')
    .startOf('month')
    .format(MMM);
  const prevMonthFirstDay = moment().subtract(1, 'months').startOf('month');
  const prevMonthLastDay = moment().subtract(1, 'months').endOf('month');
  const currentMonth = moment().startOf('month').format(MMM);
  const currentMonthFirstDay = moment().startOf('month');
  const currentMonthLastDay = moment().endOf('month');

  let views = [];
  if (moment().date() <= midDayOfTheMonth) {
    if (isMonthly) {
      views = [
        {
          label: `${previousMonth} 1 - ${midDayOfTheMonth}`,
          startDate: prevMonthFirstDay.format(YYYYMMDD),
          endDate: moment(prevMonthFirstDay)
            .add(midDayOfTheMonth - 1, 'days')
            .format(YYYYMMDD),
        },
        {
          label: `${previousMonth} ${
            midDayOfTheMonth + 1
          } - ${prevMonthLastDay.daysInMonth()}`,
          startDate: moment(prevMonthFirstDay)
            .add(midDayOfTheMonth, 'days')
            .format(YYYYMMDD),
          endDate: prevMonthLastDay.format(YYYYMMDD),
        },
        {
          label: `${currentMonth} 1 - ${midDayOfTheMonth}`,
          startDate: currentMonthFirstDay.format(YYYYMMDD),
          endDate: moment(currentMonthFirstDay)
            .add(midDayOfTheMonth - 1, 'days')
            .format(YYYYMMDD),
        },
      ];
    } else {
      views = [
        {
          label: `${previousMonth} ${
            midDayOfTheMonth + 1
          } - ${prevMonthLastDay.daysInMonth()}`,
          startDate: moment(prevMonthFirstDay)
            .add(midDayOfTheMonth, 'days')
            .format(YYYYMMDD),
          endDate: prevMonthLastDay.format(YYYYMMDD),
        },
        {
          label: `${currentMonth} 1 - ${midDayOfTheMonth}`,
          startDate: currentMonthFirstDay.format(YYYYMMDD),
          endDate: moment(currentMonthFirstDay)
            .add(midDayOfTheMonth - 1, 'days')
            .format(YYYYMMDD),
        },
      ];
    }
  } else {
    // eslint-disable-next-line no-lonely-if
    if (isMonthly) {
      views = [
        {
          label: `${previousMonth} 1 - ${midDayOfTheMonth}`,
          startDate: prevMonthFirstDay.format(YYYYMMDD),
          endDate: moment(prevMonthFirstDay)
            .add(midDayOfTheMonth - 1, 'days')
            .format(YYYYMMDD),
        },
        {
          label: `${previousMonth} ${
            midDayOfTheMonth + 1
          } - ${prevMonthLastDay.daysInMonth()}`,
          startDate: moment(prevMonthFirstDay)
            .add(midDayOfTheMonth, 'days')
            .format(YYYYMMDD),
          endDate: prevMonthLastDay.format(YYYYMMDD),
        },
        {
          label: `${currentMonth} 1 - ${midDayOfTheMonth}`,
          startDate: currentMonthFirstDay.format(YYYYMMDD),
          endDate: moment(currentMonthFirstDay)
            .add(midDayOfTheMonth - 1, 'days')
            .format(YYYYMMDD),
        },
        {
          label: `${currentMonth} ${
            midDayOfTheMonth + 1
          } - ${currentMonthLastDay.daysInMonth()}`,
          startDate: moment(currentMonthFirstDay)
            .add(midDayOfTheMonth, 'days')
            .format(YYYYMMDD),
          endDate: currentMonthLastDay.format(YYYYMMDD),
        },
      ];
    } else {
      views = [
        {
          label: `${currentMonth} 1 - ${midDayOfTheMonth}`,
          startDate: currentMonthFirstDay.format(YYYYMMDD),
          endDate: moment(currentMonthFirstDay)
            .add(midDayOfTheMonth - 1, 'days')
            .format(YYYYMMDD),
        },
        {
          label: `${currentMonth} ${
            midDayOfTheMonth + 1
          } - ${currentMonthLastDay.daysInMonth()}`,
          startDate: moment(currentMonthFirstDay)
            .add(midDayOfTheMonth, 'days')
            .format(YYYYMMDD),
          endDate: currentMonthLastDay.format(YYYYMMDD),
        },
      ];
    }
  }
  return views;
};

export const getInitialViewIndex = (dateViewList) => {
  const targetDate = moment().format(YYYYMMDD);
  let viewIndex = null;
  dateViewList.map((dateView, idx) => {
    if (
      moment(targetDate).isBetween(
        dateView.startDate,
        moment(dateView.endDate).add(1, 'days'),
        'days',
        '[]'
      )
    ) {
      viewIndex = idx;
    }
    return viewIndex;
  });
  return viewIndex;
};
